import React, { createContext, useContext, ReactNode } from 'react';

/**
 * Application configuration fetched from the API
 * Replaces environment variables with runtime configuration
 */
export interface AppConfig {
  // Okta configuration
  oktaIssuer: string;
  reactClientId: string;

  // Application metadata
  appVersion: string;

  // Integration IDs
  menderSsoGuid: string;
  msalClientId: string;
  msalTenantId: string;

  // URLs
  pepsenseUrl: string;

  // Cluster information
  clusterDetails: string;
  clusterZone: string;
}

const AppConfigContext = createContext<AppConfig | null>(null);

export function useAppConfig(): AppConfig {
  const config = useContext(AppConfigContext);
  if (!config) {
    throw new Error('useAppConfig must be used within AppConfigProvider');
  }
  return config;
}

type Props = {
  config: AppConfig;
  children: ReactNode;
};

export function AppConfigProvider({ config, children }: Props) {
  return (
    <AppConfigContext.Provider value={config}>
      {children}
    </AppConfigContext.Provider>
  );
}
